import React, { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import { motion } from "framer-motion";
import { api, formatRON } from "@/lib/api";
import { useLang } from "@/context/LanguageContext";

const OrderConfirmation = () => {
  const { id } = useParams();
  const { t } = useLang();
  const [order, setOrder] = useState(null);
  const [notFound, setNotFound] = useState(false);

  useEffect(() => {
    api.get(`/orders/${id}`).then((r) => setOrder(r.data)).catch(() => setNotFound(true));
  }, [id]);

  if (notFound) {
    return <main className="flex min-h-screen items-center justify-center pt-28 font-mono text-xs uppercase tracking-widest">ORDER NOT FOUND</main>;
  }
  if (!order) {
    return <main className="flex min-h-screen items-center justify-center pt-28 font-mono text-xs uppercase tracking-widest">LOADING…</main>;
  }

  return (
    <main className="pt-28" data-testid="order-confirmation">
      <div className="mx-auto max-w-2xl p-6 sm:p-12">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.7, ease: [0.16, 1, 0.3, 1] }}
          className="border border-border"
        >
          <div className="border-b border-border bg-foreground p-8 text-background">
            <div className="font-mono text-xs uppercase tracking-widest text-accent">✓ {t.confirm.title}</div>
            <h1 className="mt-3 text-4xl font-black uppercase tracking-tighter sm:text-5xl">{t.confirm.thanks}</h1>
            <div className="mt-4 font-mono text-xs uppercase tracking-widest text-background/70">
              {t.confirm.order}: {order.order_number}
            </div>
          </div>
          <div className="p-8">
            {order.items.map((i, idx) => (
              <div key={idx} className="flex justify-between border-b border-border py-3 font-mono text-xs uppercase tracking-widest">
                <span>{i.name} · {i.size} · {i.color} · x{i.qty}</span>
                <span>{formatRON(i.price * i.qty)}</span>
              </div>
            ))}
            <div className="mt-4 flex items-end justify-between">
              <span className="font-mono text-xs uppercase tracking-widest">{t.cart.total}</span>
              <span className="text-3xl font-black">{formatRON(order.total)}</span>
            </div>
            <div className="mt-6 font-mono text-[10px] uppercase leading-relaxed tracking-widest text-muted-foreground">
              {order.customer.name} — {order.customer.address}, {order.customer.city}, {order.customer.county} {order.customer.postal}
            </div>
          </div>
        </motion.div>
        <Link to="/shop" className="mt-8 inline-block border border-border px-8 py-4 font-mono text-xs uppercase tracking-widest transition-colors hover:bg-foreground hover:text-background" data-testid="back-to-shop">
          {t.confirm.back}
        </Link>
      </div>
    </main>
  );
};

export default OrderConfirmation;
